module.exports = __webpack_public_path__ + "static/story6-small-thumbnails-100x100-e496fbe7623916eab35b51489029dde1.jpg";